import React from "react";
import PropTypes from "prop-types";
import Select from "react-select";

const PerPageSelect = ({ perPage, handleChange }) => {
  const values = [1, 10, 25];
  const options = values.map(value => ({
    value,
    label: `${value}`
  }));

  return (
    <Select
      className="select-up"
      clearable={false}
      options={options}
      searchable={false}
      value={perPage}
      onChange={selectedOption => handleChange(selectedOption.value)}
    />
  );
};
PerPageSelect.propTypes = {
  perPage: PropTypes.number.isRequired,
  handleChange: PropTypes.func.isRequired
};

export default PerPageSelect;



// WEBPACK FOOTER //
// ./src/components/runsheets/list/PerPageSelect.js